import { render, staticRenderFns } from "./SchoolCallingSheet.vue?vue&type=template&id=8fd60c36&scoped=true"
import script from "./SchoolCallingSheet.vue?vue&type=script&lang=js"
export * from "./SchoolCallingSheet.vue?vue&type=script&lang=js"
import style0 from "./SchoolCallingSheet.vue?vue&type=style&index=0&id=8fd60c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd60c36",
  null
  
)

export default component.exports